module.exports = __webpack_public_path__ + "static/media/998659.809cc17e.png";